export default __webpack_public_path__ + "static/media/latest-news-img12.071f2aa1.jpg";